/**
 * Psychiatrie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: PSY
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const psychiatrie = defineSpecialty(
{
  "id": "psychiatrie",
  "label": "Psychiatrie",
  "short": "psychiatrie",
  "scope": "Psychiatrie, psychothérapie et addictologie",
  "aliases": [
    "PSY"
  ],
  "doctorSpecs": [
    "Psychiatrie"
  ],
  "featureFlag": "ux.v2.psychiatrie",
  "theme": {
    "primary": "oklch(0.66 0.12 300)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "assessment",
      "label": "Évaluation",
      "icon": "ClipboardCheck",
      "route": "/clinical/assessment",
      "order": 2,
      "requires": []
    },
    {
      "id": "therapy",
      "label": "Thérapie",
      "icon": "MessagesSquare",
      "route": "/clinical/therapy",
      "order": 3,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "scales",
      "label": "Échelles",
      "icon": "ListChecks",
      "component": "PsychScalePanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Psychiatrie",
    "subSpecialties": [
      "Consultation",
      "Entretien psychiatrique",
      "Psychothérapie"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "F00",
      "F20",
      "F32",
      "F41",
      "F10"
    ],
    "loinc": [
      "44249-1",
      "69779-8"
    ],
    "snomed": []
  },
  "deviceProfiles": [],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default psychiatrie;
